"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const LoadingBody_1 = __importDefault(require("./LoadingBody"));
exports.default = LoadingBody_1.default;
//# sourceMappingURL=index.js.map